import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppDataComponent } from 'application/project/api/EppDataComponent';

export const eppDataComponentAdapter = createEntityAdapter<IEppDataComponent, number>({
  selectId: (project) => project.eppDataComponentID,
});
